import {
  validateAsn,
  validateBmHeaderFields,
  validateCity,
  validateCountryCode,
  validateHeaderGlob,
  validateHeaderName,
  validateHostnameGlob,
  validateIpOrCidr,
  validateIpOrCidrOrRange,
  validateIpv4Only,
  validateJa3,
  validateJa4,
  validatePathGlob,
  validateUid,
} from "./yupCommonFields";
import { FIELD_NONE, OPERATOR_NONE, rowIsStarted } from "./matchRowHelpers";

export const BM_FIELD_NONE = FIELD_NONE;
export { OPERATOR_NONE };

/** @returns {{ valid: boolean, message?: string }} */
export function validateBmFieldValue(field, value, { headerName, headerGlob } = {}) {
  switch (field) {
    case "cidrs":
      return validateIpOrCidr(value);
    case "uids":
      return validateUid(value);
    case "ja3s":
      return validateJa3(value);
    case "ja4s":
      return validateJa4(value);
    case "paths":
      return validatePathGlob(value);
    case "asns":
      return validateAsn(value);
    case "countries":
      return validateCountryCode(value);
    case "headers":
      return validateBmHeaderFields(headerName, headerGlob);
    default:
      return { valid: true };
  }
}

/** @returns {{ valid: boolean, message?: string }} */
export function validateDdosIpv4Field(value) {
  return validateIpv4Only(value);
}

/** @returns {{ valid: boolean, message?: string }} */
export function validateDdosFieldValue(field, value) {
  switch (field) {
    case "cidrs":
      return validateIpv4Only(value);
    case "hostnames":
      return validateHostnameGlob(value);
    case "countries":
      return validateCountryCode(value);
    case "cities":
      return validateCity(value);
    case "asns":
      return validateAsn(value);
    default:
      return { valid: true };
  }
}

/** @returns {{ field?: string, operator?: string, value?: string, headerName?: string, headerGlob?: string }} */
export function validateBmMatchRow(row, { fieldNone = BM_FIELD_NONE } = {}) {
  const errors = {};
  if (!rowIsStarted(row, fieldNone)) return errors;

  if (!row.field || row.field === fieldNone) {
    errors.field = "Select a field";
    return errors;
  }
  if (!row.operator || row.operator === OPERATOR_NONE) {
    errors.operator = "Select an operator";
    return errors;
  }

  const result = validateBmFieldValue(row.field, row.value, {
    headerName: row.headerName,
    headerGlob: row.headerGlob,
  });
  if (!result.valid) {
    if (row.field === "headers") {
      if (!String(row.headerName ?? "").trim()) errors.headerName = result.message;
      else if (result.message?.includes("glob")) errors.headerGlob = result.message;
      else errors.headerName = result.message;
    } else {
      errors.value = result.message;
    }
  }
  return errors;
}

export {
  validateAsn,
  validateCity,
  validateCountryCode,
  validateHeaderGlob,
  validateHeaderName,
  validateHostnameGlob,
  validateIpOrCidr,
  validateIpOrCidrOrRange,
  validateIpv4Only,
  validateJa3,
  validateJa4,
  validatePathGlob,
  validateUid,
} from "./yupCommonFields";
